import React from 'lib/react';
import {
  EVGrid, EVTypography, EVCard, EVCardContent, EVTooltip, EVInfoOutlinedIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { getPropertyDataDisplayItems } from './PropertyData.utils';
import PropertyDataDisplayStyles from './PropertyDataDisplayStyles';

function StructureDataCard({ structure, index }) {
  const classes = PropertyDataDisplayStyles();
  const { t } = useTranslation();
  const structureNumber = index + 1;

  const dataItems = getPropertyDataDisplayItems(structure, t);

  return (
    <EVCard key={index} className={classes.dataCard}>
      <EVCardContent>
        <EVTypography className={classes.structureTitle}>
          {t('property_data__structure')}
          {' '}
          {structureNumber}
        </EVTypography>
        <EVGrid className={classes.dataGrid}>
          {dataItems.map((item) => (
            <EVGrid key={item.label} className={classes.dataItem}>
              <EVTypography className={classes.dataLabel}>{item.label}</EVTypography>
              {item.tooltipTitle && (
                <EVTooltip arrow title={item.tooltipTitle}>
                  <span style={{ height: '16px', width: '16px' }}>
                    <EVInfoOutlinedIcon style={{ height: '16px', width: '16px' }} />
                  </span>
                </EVTooltip>
              )}
              <EVTypography className={classes.dataValue}>
                {item.value}
              </EVTypography>
            </EVGrid>
          ))}
        </EVGrid>
      </EVCardContent>
    </EVCard>
  );
}

StructureDataCard.propTypes = {
  structure: PropTypes.shape({
    roof: PropTypes.shape({
      structure_roof_age: PropTypes.shape({
        value: PropTypes.string,
        unit: PropTypes.string,
        reasons: PropTypes.arrayOf(PropTypes.string),
      }),
      structure_roof_predominant_pitch: PropTypes.shape({
        value: PropTypes.string,
      }),
      structure_roof_solar_panel_presence: PropTypes.shape({
        value: PropTypes.string,
      }),
      structure_roof_condition_rating: PropTypes.shape({
        value: PropTypes.string,
      }),
      structure_roof_facet_count: PropTypes.shape({
        value: PropTypes.string,
      }),
      structure_roof_material_primary: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default StructureDataCard;
